import { render, staticRenderFns } from "./ReportDataModal.vue?vue&type=template&id=524bf972&"
import script from "./ReportDataModal.vue?vue&type=script&lang=js&"
export * from "./ReportDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports